<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter, useRoute } from '#imports';
import { getSectionById } from '~/services/musicSectionMapConfig';

const router = useRouter();
const route = useRoute();

// 默认重定向到全球榜单或你希望的默认section
const DEFAULT_SECTION = 'global-trending'; // 修改为你希望的默认section

onMounted(() => {
  // 检查是否有旧格式的查询参数
  const chartId = route.query.chart as string;
  const category = route.query.category as string;
  const q = route.query.q as string;

  if (chartId) {
    // 如果是榜单，尝试查找匹配的section
    const sectionInfo = getSectionById(chartId, 'rank');
    if (sectionInfo && sectionInfo.path) {
      // 找到匹配的section路径，重定向到新格式
      router.replace(`/music/${sectionInfo.path}${route.query.page ? `?page=${route.query.page}` : ''}`);
    } else {
      // 不匹配，保留在[section].vue中处理
      // 不进行重定向，让[section].vue通过旧格式处理
    }
  } else if (category) {
    // 如果是分类，直接使用category作为路径
    router.replace(`/music/${category}${route.query.page ? `?page=${route.query.page}` : ''}`);
  } else if (q) {
    // 如果是搜索，重定向到搜索页面
    router.replace(`/music/search?q=${q}`);
  } else {
    // 没有查询参数，重定向到默认section
    router.replace(`/music/${DEFAULT_SECTION}`);
  }
});
</script>

<template>
  <div class="flex justify-center items-center min-h-screen">
    <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
  </div>
</template> 